/* 

Copyright© Celligence International, LLC - 2023

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

/**
 * This opens PDF on a new tab, where, theoretically, the user can choose to download
 * this is a limitation of Safari on iPhone from what I've researched. 
 * @param {*} documentData the envelope data received from the rest server
 * @returns nothing
 */
const DownloadForMobileSafari = async (documentData) => {
  const binaryString = atob(documentData.documentBase64);
  const byteNumbers = new Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    byteNumbers[i] = binaryString.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" } );
  const blobURL = window.URL.createObjectURL(blob);
  const reader = new FileReader();

  reader.onloadend = () => {
    const a = document.createElement("a");
    a.href = blobURL;
    a.download = `signed-${documentData.docId}.pdf`;
    a.click();
    a.remove()
  }
  reader.readAsDataURL(blob);
}

export default DownloadForMobileSafari;